import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-223dccf3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tab_pane_list"
}
const _hoisted_2 = { class: "tab_pane_footer" }
const _hoisted_3 = { class: "msg_item_content_title" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "tab_pane_header" }
const _hoisted_7 = { class: "empty_wrap" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty_txt" }, "暂无未读通知", -1))

import { computed } from 'vue';
import { emptyMsg } from '@/assets';
import router from '@/router';
import { RootMsg } from '@/store/modules/home/type';

interface Iprops {
  resource?: RootMsg[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TabPane',
  props: {
    resource: null
  },
  emits: ['closeMenu', 'getInfo'],
  setup(__props: any, { emit }) {

const props = __props as {
  resource?: RootMsg[];
};


const data = computed(() => props.resource);

const toMsgCenter = () => {
  emit('closeMenu');
  router.push({ name: 'MessageCenter' });
};
const getMsgInfo = (key: number) => {
  emit('getInfo', key);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_unref(data) && _unref(data).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "link",
            class: "msg_menu_link",
            onClick: toMsgCenter
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看更多")
            ]),
            _: 1
          })
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "tab_pane_item"
          }, [
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1)
            ]),
            _createVNode(_component_a_button, {
              type: "link",
              class: "msg_menu_link see_font",
              onClick: ($event: any) => (getMsgInfo(index))
            }, {
              default: _withCtx(() => [
                _createTextVNode("立即查看")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_button, {
            type: "link",
            class: "msg_menu_link",
            onClick: toMsgCenter
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看更多")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: _unref(emptyMsg),
            alt: ""
          }, null, 8, _hoisted_8),
          _hoisted_9
        ])
      ]))
}
}

})